import '../styles/styles.css';
import '../styles/index.css';

// Script funcional para o index.html (sem componentização)

// Menu responsivo do navbar
const menuToggleButton = document.querySelector('[data-collapse-toggle="navbar-sticky"]');
const navbarMenu = document.getElementById('navbar-sticky');
if (menuToggleButton && navbarMenu) {
  menuToggleButton.addEventListener('click', () => {
    const isExpanded = menuToggleButton.getAttribute('aria-expanded') === 'true';
    menuToggleButton.setAttribute('aria-expanded', !isExpanded);
    navbarMenu.classList.toggle('hidden');
  });
}

// Lógica para esconder o texto do logo no scroll
document.addEventListener('DOMContentLoaded', () => {
  const logoText = document.querySelector('.self-center');
  const navbar = document.querySelector('nav');

  window.addEventListener('scroll', () => {
    if (window.scrollY > 50) {
      logoText.style.opacity = '0';
      logoText.style.transform = 'translateX(-20px)';
    } else {
      logoText.style.opacity = '1';
      logoText.style.transform = 'translateX(0)';
    }
  });
});
